class ClanStoreLocator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.search = this.querySelector('[data-locator-search]');
    this.region = this.querySelector('[data-locator-region]');
    this.grid = this.querySelector('[data-locator-grid]');
    if (!this.search || !this.region || !this.grid) return;
    this.initialized = true;
    this.count = this.querySelector('[data-locator-count]');
    this.empty = this.querySelector('[data-locator-empty]');
    this.clears = [...this.querySelectorAll('[data-locator-clear]')];
    this.allCities = this.region.options[0]?.textContent || 'All cities';
    this.events = new AbortController();
    this.baseSearch = new WeakMap();
    const options = { signal: this.events.signal };
    this.search.addEventListener('input', () => this.filter(), options);
    this.region.addEventListener('change', () => this.filter(), options);
    this.clears.forEach((button) => button.addEventListener('click', () => this.clear(), options));
    const refresh = () => {
      cancelAnimationFrame(this.refreshFrame);
      this.refreshFrame = requestAnimationFrame(() => this.refresh());
    };
    document.addEventListener('shopify:section:load', refresh, options);
    document.addEventListener('shopify:section:unload', refresh, options);
    document.addEventListener('shopify:block:select', (event) => {
      const card = this.cards.find((item) => item.dataset.locatorBlockId === event.detail?.blockId);
      if (!card) return;
      if (card.hidden) this.clear(false);
      card.scrollIntoView({ behavior: 'auto', block: 'center' });
    }, options);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.refresh(), { ...options, once: true });
    }
    this.refresh();
  }
  disconnectedCallback() {
    this.events?.abort();
    cancelAnimationFrame(this.refreshFrame);
    this.initialized = false;
  }
  stateName(value) {
    const state = (value || '').trim().replace(/\s+/g, ' ');
    const aliases = { telanagana: 'Telangana', tamilnadu: 'Tamil Nadu' };
    return aliases[state.toLowerCase()] || state;
  }
  refresh() {
    const selected = this.region.value;
    this.grid.querySelectorAll('[data-locator-extra]').forEach((card) => card.remove());
    let remaining = Math.max(0, 150 - this.grid.querySelectorAll('[data-locator-card]').length);
    document.querySelectorAll('template[data-locator-stores]').forEach((template) => {
      template.content.querySelectorAll('[data-locator-card]').forEach((source) => {
        if (remaining < 1) return;
        const card = source.cloneNode(true);
        card.dataset.locatorExtra = template.id;
        this.grid.append(card);
        remaining -= 1;
      });
    });
    this.cards = [...this.grid.querySelectorAll('[data-locator-card]')];
    const groups = new Map();
    this.cards.forEach((card) => {
      const city = (card.dataset.city || card.dataset.region || '').trim().replace(/\s+/g, ' ');
      const state = this.stateName(card.dataset.state);
      const group = state || this.region.dataset.otherStateLabel || 'Other locations';
      const key = JSON.stringify([state.toLowerCase(), city.toLowerCase()]);
      card.dataset.region = key;
      if (!this.baseSearch.has(card)) this.baseSearch.set(card, card.dataset.search || '');
      card.dataset.search = `${this.baseSearch.get(card)} ${city} ${state}`.toLowerCase();
      if (!city) return;
      const groupKey = group.toLowerCase();
      if (!groups.has(groupKey)) groups.set(groupKey, { label: group, cities: new Map() });
      groups.get(groupKey).cities.set(key, { label: state ? `${city}, ${state}` : city, key });
    });
    this.region.replaceChildren(new Option(this.allCities, ''));
    [...groups.values()].sort((a, b) => a.label.localeCompare(b.label)).forEach((group) => {
      const optgroup = document.createElement('optgroup');
      optgroup.label = group.label;
      [...group.cities.values()].sort((a, b) => a.label.localeCompare(b.label)).forEach((city) => {
        optgroup.append(new Option(city.label, city.key));
      });
      this.region.append(optgroup);
    });
    if ([...this.region.options].some((option) => option.value === selected)) this.region.value = selected;
    this.filter();
  }
  filter() {
    const query = this.search.value.trim().toLowerCase();
    const region = this.region.value;
    let visible = 0;
    this.cards.forEach((card) => {
      const show = (!query || card.dataset.search.includes(query)) && (!region || card.dataset.region === region);
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (this.count) this.count.textContent = visible;
    if (this.empty) this.empty.hidden = visible !== 0;
    this.clears.forEach((button) => { if (!button.closest('[data-locator-empty]')) button.hidden = !query && !region; });
  }
  clear(focus = true) {
    this.search.value = '';
    this.region.value = '';
    this.filter();
    if (focus) this.search.focus();
  }
}
if (!customElements.get('clan-store-locator')) customElements.define('clan-store-locator', ClanStoreLocator);
